export const water = {
    waterLightest: '#f3faff',
    waterLight: '#d7ecff',
    water: '#b0d9ff',
    waterDark: '#5e8dba',
    waterDarkest: '#232b33',
};
